<template>
  <div class="columns">
    <div v-if="!loading" class="profile column is-half is-offset-one-quarter">
      <div class="card">
                <div class="card-header">
                    <p class="card-header-title">
                        <span v-if="hasProfile">Profil</span>
                        <span v-if="!hasProfile">Välkommen</span>
                    </p>
                    <a v-if="hasProfile" v-on:click="edit = !edit" class="card-header-icon" aria-label="close">
                        <span class="icon has-text-grey-light">
                        <i class="fas fa-edit" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
                <div class="card-content">
                  <ProfileForm v-if="!hasProfile || edit "/>
                  <ProfileViewer v-if="hasProfile && !edit"/>
                </div>
            </div>
      
    </div>
  </div>
</template>

<script>
import ProfileViewer from "@/components/ProfileViewer.vue";
import ProfileForm from "@/components/ProfileForm.vue";

export default {
  name: "Profile",
  components: {
    ProfileViewer,
    ProfileForm
  },
  data: function() {
    return {
      loading: false,
      edit: false,
    }
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch("load_user");
    this.loading = false;
  },
  computed: {
    hasProfile() {
      return this.$store.getters.hasProfile;
    },
    profile() {
      return JSON.parse(JSON.stringify(this.$store.user.artistProfile || {firstName:"",lastName:"",city:"",title:"",homepage:"",slug:""}))
    }
  }
  
}
</script>
